import { render } from "./Calculations.vue?vue&type=template&id=2babcb95"
import script from "./Calculations.vue?vue&type=script&lang=ts"
export * from "./Calculations.vue?vue&type=script&lang=ts"
script.render = render

export default script